import PropTypes from 'prop-types';
import React from 'react';

const CLangInactive = ({ className }) => (
  <svg
    className={className}
    width="1731"
    height="857"
    viewBox="0 0 1731 857"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1112_10841)">
      <g filter="url(#filter0_ddd_1112_10841)">
        <rect x="704" y="252" width="624" height="556" rx="12" fill="#1B2628" />
      </g>
      <rect opacity="0.3" x="704" y="473" width="624" height="24" fill="#FD0054" />
      <rect opacity="0.1" x="753" y="289" width="1" height="519" fill="white" />
      <text
        opacity="0.4"
        fill="white"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        fontFamily="Roboto Mono"
        fontSize="14"
        letterSpacing="0em"
      >
        <tspan x="728.592" y="320.938">
          6&#10;
        </tspan>
        <tspan x="728.592" y="341.938">
          7&#10;
        </tspan>
        <tspan x="728.592" y="362.938">
          8&#10;
        </tspan>
        <tspan x="728.592" y="383.938">
          9&#10;
        </tspan>
        <tspan x="720.184" y="404.938">
          10&#10;
        </tspan>
        <tspan x="720.184" y="425.938">
          11&#10;
        </tspan>
        <tspan x="720.184" y="446.938">
          12&#10;
        </tspan>
        <tspan x="720.184" y="467.938">
          13&#10;
        </tspan>
        <tspan x="720.184" y="488.938">
          14&#10;
        </tspan>
        <tspan x="720.184" y="509.938">
          15&#10;
        </tspan>
        <tspan x="720.184" y="530.938">
          16&#10;
        </tspan>
        <tspan x="720.184" y="551.938">
          17&#10;
        </tspan>
        <tspan x="720.184" y="572.938">
          18&#10;
        </tspan>
        <tspan x="720.184" y="593.938">
          19&#10;
        </tspan>
        <tspan x="720.184" y="614.938">
          20&#10;
        </tspan>
        <tspan x="720.184" y="635.938">
          21&#10;
        </tspan>
        <tspan x="720.184" y="656.938">
          22&#10;
        </tspan>
        <tspan x="720.184" y="677.938">
          23&#10;
        </tspan>
        <tspan x="720.184" y="698.938">
          24&#10;
        </tspan>
        <tspan x="720.184" y="719.938">
          25&#10;
        </tspan>
        <tspan x="720.184" y="740.938">
          26&#10;
        </tspan>
        <tspan x="720.184" y="761.938">
          27&#10;
        </tspan>
        <tspan x="720.184" y="782.938">
          28
        </tspan>
      </text>
      <path
        d="M704 264C704 257.373 709.373 252 716 252H1316C1322.63 252 1328 257.373 1328 264V288H704V264Z"
        fill="#1B2628"
      />
      <text
        fill="white"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        fontFamily="Poppins"
        fontSize="14"
        fontWeight="600"
        letterSpacing="0em"
      >
        <tspan x="1012.04" y="274.9">
          C
        </tspan>
      </text>
      <circle cx="726" cy="270" r="6" fill="#FD0054" />
      <circle cx="746" cy="270" r="6" fill="#FFB31A" />
      <circle cx="766" cy="270" r="6" fill="#00CC21" />
      <rect opacity="0.1" x="704" y="288" width="624" height="1" fill="white" />
      <text
        fill="white"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        fontFamily="Roboto Mono"
        fontSize="14"
        letterSpacing="0em"
      >
        <tspan x="778" y="320.938">
          #
        </tspan>
        <tspan x="836.857" y="320.938">
          {' '}
        </tspan>
        <tspan x="920.939" y="320.938">
          {' '}
        </tspan>
        <tspan x="778" y="341.938" />
        <tspan x="803.225" y="362.938">
          {' '}
          visited[MAX_NODES];{' '}
        </tspan>
        <tspan x="778" y="383.938">
          {' '}
        </tspan>
        <tspan x="778" y="404.938" />
        <tspan x="811.633" y="425.938">
          {' '}
        </tspan>
        <tspan x="912.531" y="425.938">
          (Graph g,{' '}
        </tspan>
        <tspan x="1021.84" y="425.938">
          {' '}
          nV, Vertex src, Vertex dest)&#10;
        </tspan>
        <tspan x="778" y="446.938">
          {'{'}&#10;
        </tspan>
        <tspan x="778" y="467.938">
          {' '}
          Vertex v;&#10;
        </tspan>
        <tspan x="778" y="488.938">
          {' '}
        </tspan>
        <tspan x="836.857" y="488.938">
          {' '}
          (v ={' '}
        </tspan>
        <tspan x="895.715" y="488.938">
          ; v &lt; nV; v++) visited[v] = -
        </tspan>
        <tspan x="1147.96" y="488.938">
          ;&#10;
        </tspan>
        <tspan x="778" y="509.938" />
        <tspan x="778" y="530.938">
          {' '}
          visited[src] = src;&#10;
        </tspan>
        <tspan x="778" y="551.938">
          {' '}
          queue Q =
        </tspan>
        <tspan x="936.98" y="551.938">
          ();&#10;
        </tspan>
        <tspan x="778" y="572.938">
          {' '}
        </tspan>
        <tspan x="912.531" y="572.938">
          (Q, src);&#10;
        </tspan>
        <tspan x="778" y="593.938">
          {' '}
        </tspan>
        <tspan x="853.674" y="593.938">
          {' '}
          (!
        </tspan>
        <tspan x="979.797" y="593.938">
          (Q))&#10;
        </tspan>
        <tspan x="778" y="614.938">
          {' '}
          {'{'}&#10;
        </tspan>
        <tspan x="778" y="635.938">
          {' '}
          v ={' '}
        </tspan>
        <tspan x="979.797" y="635.938">
          (Q);&#10;
        </tspan>
        <tspan x="778" y="656.938">
          {' '}
          Vertex w;&#10;
        </tspan>
        <tspan x="778" y="677.938">
          {' '}
        </tspan>
        <tspan x="870.49" y="677.938">
          {' '}
          (w = 0; w &lt; nV; w++)&#10;
        </tspan>
        <tspan x="778" y="698.938">
          {' '}
        </tspan>
        <tspan x="895.715" y="698.938">
          {' '}
          (
        </tspan>
        <tspan x="979.797" y="698.938">
          (g, v, w) &amp;&amp; visited[w] == -
        </tspan>
        <tspan x="1223.63" y="698.938">
          )&#10;
        </tspan>
        <tspan x="778" y="719.938">
          {' '}
          {'{'}&#10;
        </tspan>
        <tspan x="778" y="740.938">
          {' '}
          visited[w] = v;&#10;
        </tspan>
        <tspan x="778" y="761.938">
          {' '}
        </tspan>
        <tspan x="929.348" y="761.938">
          {' '}
          (w == dest)&#10;
        </tspan>
        <tspan x="778" y="782.938">
          {' '}
        </tspan>
        <tspan x="996.613" y="782.938">
          {' '}
        </tspan>
        <tspan x="1038.65" y="782.938">
          ;
        </tspan>
      </text>
      <text
        fill="#FFD500"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        fontFamily="Roboto Mono"
        fontSize="14"
        letterSpacing="0em"
      >
        <tspan x="786.408" y="320.938">
          define
        </tspan>
        <tspan x="778" y="362.938">
          int
        </tspan>
        <tspan x="778" y="425.938">
          bool
        </tspan>
        <tspan x="996.613" y="425.938">
          int
        </tspan>
        <tspan x="811.633" y="488.938">
          for
        </tspan>
        <tspan x="811.633" y="593.938">
          while
        </tspan>
        <tspan x="845.266" y="677.938">
          for
        </tspan>
        <tspan x="878.898" y="698.938">
          if
        </tspan>
        <tspan x="912.531" y="761.938">
          if
        </tspan>
        <tspan x="946.164" y="782.938">
          return
        </tspan>
      </text>
      <text
        fill="#FD6A00"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        fontFamily="Roboto Mono"
        fontSize="14"
        letterSpacing="0em"
      >
        <tspan x="845.266" y="320.938">
          MAX_NODES
        </tspan>
        <tspan x="820.041" y="425.938">
          findPathBFS
        </tspan>
      </text>
      <text
        fill="#F14AFF"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        fontFamily="Roboto Mono"
        fontSize="14"
        letterSpacing="0em"
      >
        <tspan x="929.348" y="320.938">
          1000&#10;
        </tspan>
        <tspan x="887.307" y="488.938">
          0
        </tspan>
        <tspan x="1139.55" y="488.938">
          1
        </tspan>
        <tspan x="870" y="551.938">
          newQueue
        </tspan>
        <tspan x="811.633" y="572.938">
          QueueEnqueue
        </tspan>
        <tspan x="878.898" y="593.938">
          QueueIsEmpty
        </tspan>
        <tspan x="878.898" y="635.938">
          QueueDequeue
        </tspan>
        <tspan x="912.531" y="698.938">
          adjacent
        </tspan>
        <tspan x="1215.23" y="698.938">
          1
        </tspan>
        <tspan x="1005.02" y="782.938">
          true
        </tspan>
      </text>
      <text
        fill="#798486"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        fontFamily="Roboto Mono"
        fontSize="14"
        letterSpacing="0em"
      >
        <tspan x="988.205" y="362.938">
          // array to store visiting order&#10;
        </tspan>
        <tspan x="988.205" y="383.938">
          // indexed by vertex 0..nV-1&#10;
        </tspan>
      </text>
      <g clipPath="url(#clip1_1112_10841)">
        <path
          d="M1304 737.418C1304 736.207 1303.74 735.138 1303.21 734.22C1302.7 733.317 1301.93 732.56 1300.9 731.962C1292.38 727.044 1283.85 722.142 1275.33 717.219C1273.04 715.892 1270.81 715.941 1268.53 717.287C1265.14 719.289 1248.16 729.026 1243.1 731.959C1241.02 733.166 1240 735.014 1240 737.416C1240 747.305 1240 757.194 1240 767.084C1240 768.268 1240.25 769.317 1240.75 770.222C1241.26 771.152 1242.04 771.929 1243.1 772.541C1248.16 775.474 1265.14 785.211 1268.53 787.213C1270.81 788.56 1273.04 788.608 1275.33 787.281C1283.85 782.358 1292.38 777.456 1300.9 772.538C1301.96 771.926 1302.74 771.148 1303.25 770.219C1303.75 769.315 1304 768.266 1304 767.081C1304 767.081 1304 747.308 1304 737.418Z"
          fill="white"
        />
        <path
          d="M1278.61 747.742L1288.57 747.812C1288.57 743.663 1284.37 733.5 1272.33 733.5C1264.66 733.5 1254.34 738.378 1254.34 752.403C1254.34 766.427 1264.46 771 1272.33 771C1285.09 771 1288.13 762.174 1288.13 757.187L1278.63 756.644C1278.63 756.644 1278.89 762.412 1272.28 762.412C1266.18 762.412 1265.17 754.943 1265.17 752.403C1265.17 748.541 1266.54 742.341 1272.28 742.341C1278.02 742.341 1278.61 747.742 1278.61 747.742Z"
          fill="#181A1B"
        />
      </g>
      <path
        d="M1336 484H1415V511"
        stroke="#AFB5B6"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeDasharray="0.01 10"
      />
      <circle cx="1415" cy="591" r="72" fill="url(#paint0_linear_1112_10841)" />
      <text
        fill="#181A1B"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        fontFamily="Poppins"
        fontSize="14"
        fontWeight="500"
        letterSpacing="0em"
      >
        <tspan x="1407.17" y="552.9">
          IO
        </tspan>
      </text>
      <text
        fill="#181A1B"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        fontFamily="Poppins"
        fontSize="44"
        fontWeight="300"
        letterSpacing="0em"
      >
        <tspan x="1372.37" y="598.4">
          52%
        </tspan>
      </text>
      <text
        fill="#181A1B"
        xmlSpace="preserve"
        style={{ whiteSpace: 'pre' }}
        fontFamily="Poppins"
        fontSize="13"
        letterSpacing="0em"
      >
        <tspan x="1386.7" y="621.55">
          Address:&#10;
        </tspan>
        <tspan x="1383.12" y="637.55">
          0x4553e0
        </tspan>
      </text>
    </g>
    <defs>
      <filter
        id="filter0_ddd_1112_10841"
        x="664"
        y="232"
        width="704"
        height="636"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1112_10841" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="10" />
        <feGaussianBlur stdDeviation="10" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_1112_10841"
          result="effect2_dropShadow_1112_10841"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="20" />
        <feGaussianBlur stdDeviation="20" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0784314 0 0 0 0 0.113725 0 0 0 0 0.121569 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_1112_10841"
          result="effect3_dropShadow_1112_10841"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_1112_10841"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1112_10841"
        x1="1487"
        y1="519"
        x2="1343"
        y2="663"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FCFDFD" />
        <stop offset="1" stopColor="#F4F5F6" />
      </linearGradient>
      <clipPath id="clip0_1112_10841">
        <rect width="1731" height="857" fill="white" />
      </clipPath>
      <clipPath id="clip1_1112_10841">
        <rect width="64" height="72" fill="white" transform="translate(1240 716)" />
      </clipPath>
    </defs>
  </svg>
);

CLangInactive.propTypes = {
  className: PropTypes.string,
};

CLangInactive.defaultProps = {
  className: null,
};

export default CLangInactive;
